module.exports = __webpack_public_path__ + "img/logo-sm-dark.58947763.png";